import { Column } from '@stenajs-webui/core';
import { formatServerDate } from '../../../../common/utils/dates/dateUtils';
import { DetailsFieldCell } from '../../../../common-ui/details/DetailsFieldCell';
import type { IntermodalRoute } from '../../../../gql/graphql';
import { timeOptions } from '../../../manage/details/components/sections/common';
import {
  transformDepartureTimeOption,
  transformIntermodalRouteToDropdownOption,
} from '../../utils/detailsUtils';
import { UpdateIntermodalDateInputField } from '../fields/UpdateIntermodalDateInputField';
import { UpdateIntermodalDropdownField } from '../fields/UpdateIntermodalDropdownField';

interface UpdateIntermodalDepartureSectionProps {
  alternativeRoutes: IntermodalRoute[];
}

export const UpdateIntermodalDepartureSection = ({
  alternativeRoutes,
}: UpdateIntermodalDepartureSectionProps) => {
  const today = new Date();
  return (
    <>
      <DetailsFieldCell
        label={'Intermodal route'}
        renderField={id => (
          <UpdateIntermodalDropdownField
            id={id}
            trackerCategory={'IntermodalUpdate'}
            disabled={alternativeRoutes.length <= 1}
            options={alternativeRoutes.map(transformIntermodalRouteToDropdownOption)}
            name={'route'}
            transformOption={transformIntermodalRouteToDropdownOption}
          />
        )}
      />
      <Column gap={2}>
        <DetailsFieldCell
          label={'Departure date'}
          className={'t_intermodal_departure_date'}
          renderField={id => (
            <UpdateIntermodalDateInputField
              id={id}
              width={'100%'}
              disabled
              trackerCategory={'IntermodalUpdate'}
              name={'departureDate'}
              minDate={formatServerDate(today)}
            />
          )}
        />
        <DetailsFieldCell
          label={'Dep. time'}
          renderField={id => (
            <UpdateIntermodalDropdownField
              id={id}
              trackerCategory={'IntermodalUpdate'}
              disabled
              name={'departureTime'}
              options={timeOptions}
              transformOption={transformDepartureTimeOption}
            />
          )}
        />
      </Column>
    </>
  );
};
